import Picker from 'antd-mobile/lib/picker/index';
import React, { FC, useState } from 'react';
import { PickerData } from 'antd-mobile/lib/picker/PropsType';
import { WrappedFieldProps } from 'redux-form';
import { translate, translationKeys } from 'logic/translations/translations.service';
import 'antd-mobile/lib/picker/style';

type Data = {
  value: any;
  label: string;
};

interface Props extends WrappedFieldProps {
  data: Data[];
  customOnChange?: (newValue?: any) => void;
}

export const FormInputPickerMobile: FC<Props> = ({ input, customOnChange, children, data }) => {
  const [visible, setVisible] = useState(false);

  const handleOnOk = ([value]: any) => {
    input.onChange(value);

    if (customOnChange) {
      customOnChange(value);
    }

    setVisible(false);
  };

  return (
    <Picker
      data={data as PickerData[]}
      okText={translate(translationKeys.fields.accept)}
      dismissText={translate(translationKeys.fields.cancel)}
      cols={1}
      onChange={handleOnOk}
      visible={visible}
      onDismiss={() => setVisible(false)}
      triggerType={'onClick'}
    >
      <div onClick={() => setVisible(true)}>{children}</div>
    </Picker>
  );
};
